import React, { useState } from "react";
import StateBlueprintRenderer from "../StateMachine/StateBlueprint/StateBlueprintRenderer";
import SmAiChatContainer from "./ChatboxContainer/SmAiChatContainer";
import "./StatemachineAI.css";
import ResizableComponent from "../../Layouts/ResizableComponent";
const StatemachineAI = () => {
  const [smAiData, setSmAiData] = useState(null);
  const onRecieve = (newData) => {
    setSmAiData(newData);
  };

  return (
    <div className="application_container sm_ai_container">
      <ResizableComponent resizeSide="right" storageKey="sm_ask_AI" defaultSize={244} range={[244, 600]}>
        <SmAiChatContainer onRecieve={onRecieve} />
      </ResizableComponent>
      <div className="w_100">
        <StateBlueprintRenderer aiData={smAiData} isAI={true} />
      </div>
    </div>
  );
};

export default StatemachineAI;
